import { EntityMetadata } from '@msdk/definitions'
import React, { useEffect } from 'react'

import { useI18nContext } from '../../providers'

interface Props {
  children: React.ReactNode
}

export function ComposerI18nWrapper(props: Props) {
  const entityBaseMetadata: EntityMetadata = { msProvider: 'CMPS', name: 'CMPS' } as any
  const moduleBaseMetadata: EntityMetadata = { msProvider: 'CMPS', name: 'CMPS' } as any
  const { load } = useI18nContext()

  useEffect(() => {
    load(moduleBaseMetadata, entityBaseMetadata, '')
  }, [])

  return <>{props.children}</>
}
